import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const updateMarketplaceDescAddVendorCode = (mpDescAddVendorCode: boolean) => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
        data: {
            mpDescAddVendorCode: mpDescAddVendorCode,
        },
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/marketplaces/updateMarketplacesDescAddVendorCode', params, config)
        
        if(status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setMpDescAddVendorCode,
                value: data.mpDescAddVendorCode
            })
        }
    } catch (e) {
        console.error('set mpDescAddVendorCode failed', e)
    }

}


export default updateMarketplaceDescAddVendorCode
